import { render } from "./OverlayFoundingTraderApplication.vue?vue&type=template&id=85df9f64"
import script from "./OverlayFoundingTraderApplication.vue?vue&type=script&lang=js"
export * from "./OverlayFoundingTraderApplication.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__